module.exports = __webpack_public_path__ + "static/img/1-1.ca1aed6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/1-1.png
// module id = BXaj
// module chunks = 0